export const MODULE_GLOBAL_NAME = 'global'; //BaseApi

export const SET_MANUFACTURERS = 'setManufacturers';
export const MANUFACTURERS = 'manufacturers';